import { shuffleSpread } from '../../../utils/helpers'
import Sydney from 'url:./Sydney.jpg'
import Paris from 'url:./Paris.jpg'
import Paris1 from 'url:./Paris1.jpg'
import Paris2 from 'url:./Paris2.jpg'
import Paris3 from 'url:./Paris3.jpg'
import Paris4 from 'url:./Paris4.jpg'
import Manchester from 'url:./Manchester.jpg'
import Manchester1 from 'url:./Manchester1.jpg'
import Manchester2 from 'url:./Manchester2.jpg'
import Lyon from 'url:./Lyon.jpg'
import Lyon1 from 'url:./Lyon1.jpg'
import Lyon2 from 'url:./Lyon2.jpg'
import Lyon3 from 'url:./Lyon3.jpg'
import Lyon4 from 'url:./Lyon4.jpg'
import Lyon5 from 'url:./Lyon5.jpg'
import Edinburgh from 'url:./Edinburgh.jpg'
import Edinburgh1 from 'url:./Edinburgh1.jpg'
import Edinburgh3 from 'url:./Edinburgh3.jpg'
import Edinburgh4 from 'url:./Edinburgh4.jpg'
import Edinburgh5 from 'url:./Edinburgh5.jpg'
import Edinburgh6 from 'url:./Edinburgh6.jpg'
import Brussels from 'url:./Brussels.jpg'
import Brussels1 from 'url:./Brussels1.jpg'
import Brussels2 from 'url:./Brussels2.jpg'
import Brussels3 from 'url:./Brussels3.jpg'
import Brussels4 from 'url:./Brussels4.jpg'
import Brussels5 from 'url:./Brussels5.jpg'
import London from 'url:./London.jpg'
import London1 from 'url:./London1.jpg'
import London2 from 'url:./London2.jpg'
import London3 from 'url:./London3.jpg'
import London4 from 'url:./London4.jpg'
import London5 from 'url:./London5.jpg'
import London6 from 'url:./London6.jpg'
import London7 from 'url:./London7.jpg'
import London8 from 'url:./London8.jpg'
import London9 from 'url:./London9.jpg'
import London10 from 'url:./London10.jpg'
import Vienna from 'url:./Vienna.jpg'
import Vienna1 from 'url:./Vienna1.jpg'
import Vienna2 from 'url:./Vienna2.jpg'
import Vienna3 from 'url:./Vienna3.jpg'
import Vienna4 from 'url:./Vienna4.jpg'
import Gdansk from 'url:./Gdansk.jpg'
import Gdansk1 from 'url:./Gdansk1.jpg'
import Gdansk2 from 'url:./Gdansk2.jpg'
import Gdansk3 from 'url:./Gdansk3.jpg'
import Gdansk4 from 'url:./Gdansk4.jpg'
import Gdansk5 from 'url:./Gdansk5.jpg'
import Budapest from 'url:./Budapest.jpg'
import Budapest1 from 'url:./Budapest1.jpg'
import Budapest2 from 'url:./Budapest2.jpg'
import Budapest3 from 'url:./Budapest3.jpg'
import Budapest4 from 'url:./Budapest4.jpg'
import Budapest5 from 'url:./Budapest5.jpg'
import Budapest6 from 'url:./Budapest6.jpg'
import Munich from 'url:./Munich.jpg'
import Munich1 from 'url:./Munich1.jpg'
import Munich2 from 'url:./Munich2.jpg'
import Munich3 from 'url:./Munich3.jpg'
import Munich4 from 'url:./Munich4.jpg'
import Munich5 from 'url:./Munich5.jpg'
import Munich6 from 'url:./Munich6.jpg'
import Ottawa from 'url:./Ottawa.jpg'
import Ottawa1 from 'url:./Ottawa1.jpg'
import Ottawa2 from 'url:./Ottawa2.jpg'
import Ottawa3 from 'url:./Ottawa3.jpg'
import Ottawa4 from 'url:./Ottawa4.jpg'
import Ottawa5 from 'url:./Ottawa5.jpg'
import Ottawa6 from 'url:./Ottawa6.jpg'
import Birmingham from 'url:./Birmingham.jpg'
import Birmingham1 from 'url:./Birmingham1.jpg'
import Birmingham2 from 'url:./Birmingham2.jpg'
import Birmingham3 from 'url:./Birmingham3.jpg'
import Birmingham4 from 'url:./Birmingham4.jpg'
import Birmingham5 from 'url:./Birmingham5.jpg'
import Leipzig from 'url:./Leipzig.jpg'
import Leipzig1 from 'url:./Leipzig1.jpg'
import Leipzig2 from 'url:./Leipzig2.jpg'
import Leipzig3 from 'url:./Leipzig3.jpg'
import Leipzig4 from 'url:./Leipzig4.jpg'
import Hamburg from 'url:./Hamburg.jpg'
import Hamburg1 from 'url:./Hamburg1.jpg'
import Hamburg2 from 'url:./Hamburg2.jpg'
import Hamburg3 from 'url:./Hamburg3.jpg'
import Hamburg4 from 'url:./Hamburg4.jpg'
import Hamburg5 from 'url:./Hamburg5.jpg'
import Chicago from 'url:./Chicago.jpg'
import Chicago1 from 'url:./Chicago1.jpg'
import Chicago2 from 'url:./Chicago2.jpg'
import Chicago3 from 'url:./Chicago3.jpg'
import Chicago4 from 'url:./Chicago4.jpg'
import Malaga from 'url:./Malaga.jpg'
import Malaga1 from 'url:./Malaga1.jpg'
import Malaga2 from 'url:./Malaga2.jpg'
import Malaga3 from 'url:./Malaga3.jpg'
import Malaga4 from 'url:./Malaga4.jpg'
import Malaga5 from 'url:./Malaga5.jpg'
import Plovdiv from 'url:./Plovdiv.jpg'
import Plovdiv1 from 'url:./Plovdiv1.jpg'
import Plovdiv2 from 'url:./Plovdiv2.jpg'
import Plovdiv3 from 'url:./Plovdiv3.jpg'
import Plovdiv4 from 'url:./Plovdiv4.jpg'
import Plovdiv5 from 'url:./Plovdiv5.jpg'
import Plovdiv6 from 'url:./Plovdiv6.jpg'
import Nantes from 'url:./Nantes.jpg'
import Nantes1 from 'url:./Nantes1.jpg'
import Nantes2 from 'url:./Nantes2.jpg'
import Nantes3 from 'url:./Nantes3.jpg'
import Nantes4 from 'url:./Nantes4.jpg'
import Nantes5 from 'url:./Nantes5.jpg'
import Dublin from 'url:./Dublin.jpg'
import Dublin1 from 'url:./Dublin1.jpg'
import Oslo from 'url:./Oslo.jpg'
import Oslo1 from 'url:./Oslo1.jpg'
import Oslo2 from 'url:./Oslo2.jpg'
import Oslo3 from 'url:./Oslo3.jpg'
import Oslo4 from 'url:./Oslo4.jpg'

// Photos from the October 2026 Oleshky demos (/oleshky). `link` shows as a small icon next to the city name.
// Shown in random order, like the December 2025 gallery, with photos from the same city kept apart.
const photos: { src: string; city: string; link?: string }[] = [
  { src: Sydney, city: 'sydney', link: 'https://www.facebook.com/groups/591069340942727' },
  { src: Paris, city: 'paris', link: 'https://www.facebook.com/uniondesukrainiensdefrance' },
  { src: Paris1, city: 'paris', link: 'https://www.facebook.com/uniondesukrainiensdefrance' },
  {
    src: Paris2,
    city: 'parisSep30',
    link: 'https://www.facebook.com/uniondesukrainiensdefrance',
  },
  {
    src: Paris3,
    city: 'parisSep30',
    link: 'https://www.facebook.com/uniondesukrainiensdefrance',
  },
  {
    src: Paris4,
    city: 'parisSep30',
    link: 'https://www.facebook.com/uniondesukrainiensdefrance',
  },
  {
    src: Manchester,
    city: 'manchester',
    link: 'https://www.instagram.com/mcrstandswithua/',
  },
  {
    src: Manchester1,
    city: 'manchester',
    link: 'https://www.instagram.com/mcrstandswithua/',
  },
  {
    src: Manchester2,
    city: 'manchester',
    link: 'https://www.instagram.com/mcrstandswithua/',
  },
  { src: Lyon, city: 'lyon', link: 'https://liberteua.com/' },
  { src: Lyon1, city: 'lyon', link: 'https://liberteua.com/' },
  { src: Lyon2, city: 'lyon', link: 'https://liberteua.com/' },
  { src: Lyon3, city: 'lyon', link: 'https://liberteua.com/' },
  { src: Lyon4, city: 'lyon', link: 'https://liberteua.com/' },
  { src: Lyon5, city: 'lyon', link: 'https://liberteua.com/' },
  {
    src: Edinburgh,
    city: 'edinburgh',
    link: 'https://www.ukrainianvictorycampaign.com/',
  },
  {
    src: Edinburgh1,
    city: 'edinburgh',
    link: 'https://www.ukrainianvictorycampaign.com/',
  },
  {
    src: Edinburgh3,
    city: 'edinburgh',
    link: 'https://www.ukrainianvictorycampaign.com/',
  },
  {
    src: Edinburgh4,
    city: 'edinburgh',
    link: 'https://www.ukrainianvictorycampaign.com/',
  },
  {
    src: Edinburgh5,
    city: 'edinburgh',
    link: 'https://www.ukrainianvictorycampaign.com/',
  },
  {
    src: Edinburgh6,
    city: 'edinburgh',
    link: 'https://www.ukrainianvictorycampaign.com/',
  },
  {
    src: Brussels,
    city: 'brussels',
    link: 'https://www.instagram.com/p/Ddon6ADDdSq/',
  },
  {
    src: Brussels1,
    city: 'brussels',
    link: 'https://www.instagram.com/p/Ddon6ADDdSq/',
  },
  {
    src: Brussels2,
    city: 'brussels',
    link: 'https://www.instagram.com/p/Ddon6ADDdSq/',
  },
  {
    src: Brussels3,
    city: 'brussels',
    link: 'https://www.instagram.com/p/Ddon6ADDdSq/',
  },
  {
    src: Brussels4,
    city: 'brussels',
    link: 'https://www.instagram.com/p/Ddon6ADDdSq/',
  },
  {
    src: Brussels5,
    city: 'brussels',
    link: 'https://www.instagram.com/p/Ddon6ADDdSq/',
  },
  {
    src: London,
    city: 'london',
    link: 'https://www.instagram.com/p/DdrmhWyscPX/',
  },
  {
    src: London1,
    city: 'london',
    link: 'https://www.instagram.com/p/DdrmhWyscPX/',
  },
  {
    src: London2,
    city: 'london',
    link: 'https://www.instagram.com/p/DdrmhWyscPX/',
  },
  {
    src: London3,
    city: 'london',
    link: 'https://www.instagram.com/p/DdrmhWyscPX/',
  },
  {
    src: London4,
    city: 'londonSep29',
    link: 'https://www.instagram.com/kartonky.london/',
  },
  {
    src: London5,
    city: 'londonOct1',
    link: 'https://www.instagram.com/p/Dd6KMBZMPC4/',
  },
  {
    src: Vienna,
    city: 'vienna',
    link: 'https://www.instagram.com/p/DdrVBDXiIJE/',
  },
  {
    src: Vienna1,
    city: 'vienna',
    link: 'https://www.instagram.com/p/DdrVBDXiIJE/',
  },
  {
    src: Vienna2,
    city: 'vienna',
    link: 'https://www.instagram.com/p/DdrVBDXiIJE/',
  },
  {
    src: Vienna3,
    city: 'vienna',
    link: 'https://www.instagram.com/p/DdrVBDXiIJE/',
  },
  {
    src: Vienna4,
    city: 'vienna',
    link: 'https://www.instagram.com/p/DdrVBDXiIJE/',
  },
  {
    src: Gdansk,
    city: 'gdansk',
    link: 'https://www.instagram.com/zjednoczeni_gdansk/',
  },
  {
    src: Gdansk1,
    city: 'gdansk',
    link: 'https://www.instagram.com/zjednoczeni_gdansk/',
  },
  {
    src: Gdansk2,
    city: 'gdansk',
    link: 'https://www.instagram.com/zjednoczeni_gdansk/',
  },
  {
    src: Gdansk3,
    city: 'gdansk',
    link: 'https://www.instagram.com/zjednoczeni_gdansk/',
  },
  {
    src: Gdansk4,
    city: 'gdansk',
    link: 'https://www.instagram.com/zjednoczeni_gdansk/',
  },
  {
    src: Gdansk5,
    city: 'gdansk',
    link: 'https://www.instagram.com/zjednoczeni_gdansk/',
  },
  {
    src: Budapest,
    city: 'budapest',
    link: 'https://www.facebook.com/events/786615894546731/',
  },
  {
    src: Budapest1,
    city: 'budapest',
    link: 'https://www.facebook.com/events/786615894546731/',
  },
  {
    src: Budapest2,
    city: 'budapest',
    link: 'https://www.facebook.com/events/786615894546731/',
  },
  {
    src: Budapest3,
    city: 'budapest',
    link: 'https://www.facebook.com/events/786615894546731/',
  },
  {
    src: Budapest4,
    city: 'budapest',
    link: 'https://www.facebook.com/events/786615894546731/',
  },
  {
    src: Budapest5,
    city: 'budapest',
    link: 'https://www.facebook.com/events/786615894546731/',
  },
  {
    src: Budapest6,
    city: 'budapest',
    link: 'https://www.facebook.com/events/786615894546731/',
  },
  {
    src: Munich,
    city: 'munich',
    link: 'https://www.instagram.com/p/DdbrQbKDazu/',
  },
  {
    src: Munich1,
    city: 'munich',
    link: 'https://www.instagram.com/p/DdbrQbKDazu/',
  },
  {
    src: Munich2,
    city: 'munich',
    link: 'https://www.instagram.com/p/DdbrQbKDazu/',
  },
  {
    src: Munich3,
    city: 'munich',
    link: 'https://www.instagram.com/p/DdbrQbKDazu/',
  },
  {
    src: Munich4,
    city: 'munich',
    link: 'https://www.instagram.com/p/DdbrQbKDazu/',
  },
  {
    src: Munich5,
    city: 'munich',
    link: 'https://www.instagram.com/p/DdbrQbKDazu/',
  },
  {
    src: Munich6,
    city: 'munich',
    link: 'https://www.instagram.com/p/DdbrQbKDazu/',
  },
  {
    src: Ottawa,
    city: 'ottawa',
    link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/',
  },
  {
    src: Ottawa1,
    city: 'ottawa',
    link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/',
  },
  {
    src: Ottawa2,
    city: 'ottawa',
    link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/',
  },
  {
    src: Ottawa3,
    city: 'ottawa',
    link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/',
  },
  {
    src: Ottawa4,
    city: 'ottawa',
    link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/',
  },
  {
    src: Ottawa5,
    city: 'ottawa',
    link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/',
  },
  {
    src: Ottawa6,
    city: 'ottawa',
    link: 'https://www.facebook.com/100088553050056/posts/1100188596276232/',
  },
  { src: Birmingham, city: 'birmingham' },
  { src: Birmingham1, city: 'birmingham' },
  { src: Birmingham2, city: 'birmingham' },
  { src: Birmingham3, city: 'birmingham' },
  { src: Birmingham4, city: 'birmingham' },
  { src: Birmingham5, city: 'birmingham' },
  {
    src: Hamburg,
    city: 'hamburg',
    link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655',
  },
  {
    src: Hamburg1,
    city: 'hamburg',
    link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655',
  },
  {
    src: Hamburg2,
    city: 'hamburg',
    link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655',
  },
  {
    src: Hamburg3,
    city: 'hamburg',
    link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655',
  },
  {
    src: Hamburg4,
    city: 'hamburg',
    link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655',
  },
  {
    src: Hamburg5,
    city: 'hamburg',
    link: 'https://www.facebook.com/permalink.php?story_fbid=pfbid0uWJ7WsJhvSmpVyonA3BPnzt7c4BSUsZJsx6cydi2e9AudZdrfQJCc4XKgCzvZEPcl&id=100085247455655',
  },
  {
    src: Chicago,
    city: 'chicagoOct4',
    link: 'https://www.instagram.com/p/Dd22g_4RXi5/',
  },
  {
    src: Chicago1,
    city: 'chicagoOct4',
    link: 'https://www.instagram.com/p/Dd22g_4RXi5/',
  },
  {
    src: Chicago2,
    city: 'chicagoOct4',
    link: 'https://www.instagram.com/p/Dd22g_4RXi5/',
  },
  {
    src: Chicago3,
    city: 'chicagoOct4',
    link: 'https://www.instagram.com/p/Dd22g_4RXi5/',
  },
  {
    src: Chicago4,
    city: 'chicagoOct4',
    link: 'https://www.instagram.com/p/Dd22g_4RXi5/',
  },
  {
    src: Malaga,
    city: 'malaga',
    link: 'https://www.instagram.com/p/Dd3f_mANd8F/',
  },
  {
    src: Malaga1,
    city: 'malaga',
    link: 'https://www.instagram.com/p/Dd3f_mANd8F/',
  },
  {
    src: Malaga2,
    city: 'malaga',
    link: 'https://www.instagram.com/p/Dd3f_mANd8F/',
  },
  {
    src: Malaga3,
    city: 'malaga',
    link: 'https://www.instagram.com/p/Dd3f_mANd8F/',
  },
  {
    src: Malaga4,
    city: 'malaga',
    link: 'https://www.instagram.com/p/Dd3f_mANd8F/',
  },
  {
    src: Malaga5,
    city: 'malaga',
    link: 'https://www.instagram.com/p/Dd3f_mANd8F/',
  },
  {
    src: Plovdiv,
    city: 'plovdiv',
    link: 'https://www.facebook.com/events/1129021009797960/',
  },
  {
    src: Plovdiv1,
    city: 'plovdiv',
    link: 'https://www.facebook.com/events/1129021009797960/',
  },
  {
    src: Plovdiv2,
    city: 'plovdiv',
    link: 'https://www.facebook.com/events/1129021009797960/',
  },
  {
    src: Plovdiv3,
    city: 'plovdiv',
    link: 'https://www.facebook.com/events/1129021009797960/',
  },
  {
    src: Plovdiv4,
    city: 'plovdiv',
    link: 'https://www.facebook.com/events/1129021009797960/',
  },
  {
    src: Plovdiv5,
    city: 'plovdiv',
    link: 'https://www.facebook.com/events/1129021009797960/',
  },
  {
    src: Plovdiv6,
    city: 'plovdiv',
    link: 'https://www.facebook.com/events/1129021009797960/',
  },
  {
    src: Nantes,
    city: 'nantes',
    link: 'https://www.facebook.com/events/1140799082236549',
  },
  {
    src: Nantes1,
    city: 'nantes',
    link: 'https://www.facebook.com/events/1140799082236549',
  },
  {
    src: Nantes2,
    city: 'nantes',
    link: 'https://www.facebook.com/events/1140799082236549',
  },
  {
    src: Nantes3,
    city: 'nantes',
    link: 'https://www.facebook.com/events/1140799082236549',
  },
  {
    src: Nantes4,
    city: 'nantes',
    link: 'https://www.facebook.com/events/1140799082236549',
  },
  {
    src: Nantes5,
    city: 'nantes',
    link: 'https://www.facebook.com/events/1140799082236549',
  },
  {
    src: Dublin,
    city: 'dublin',
    link: 'https://www.instagram.com/p/Ddw3XcVuHit/',
  },
  {
    src: Dublin1,
    city: 'dublin',
    link: 'https://www.instagram.com/p/Ddw3XcVuHit/',
  },
  { src: Oslo, city: 'oslo' },
  { src: Oslo1, city: 'oslo' },
  { src: Oslo2, city: 'oslo' },
  { src: Oslo3, city: 'oslo' },
  { src: Oslo4, city: 'oslo' },
  {
    src: London6,
    city: 'londonSep29',
    link: 'https://www.instagram.com/kartonky.london/',
  },
  {
    src: London7,
    city: 'londonOct3',
    link: 'https://www.instagram.com/p/Dd6KMBZMPC4/',
  },
  {
    src: London8,
    city: 'londonOct3',
    link: 'https://www.instagram.com/p/Dd6KMBZMPC4/',
  },
  {
    src: London9,
    city: 'londonOct3',
    link: 'https://www.instagram.com/p/Dd6KMBZMPC4/',
  },
  {
    src: London10,
    city: 'londonOct3',
    link: 'https://www.instagram.com/p/Dd6KMBZMPC4/',
  },
  { src: Leipzig, city: 'leipzig' },
  { src: Leipzig1, city: 'leipzig' },
  { src: Leipzig2, city: 'leipzig' },
  { src: Leipzig3, city: 'leipzig' },
  { src: Leipzig4, city: 'leipzig' },
]

// First row (shown before "see more"), always in this order; then the rest in random order; then the
// photos that always go last. Photos in `hiddenSrcs` aren't shown (the files are kept).
const firstRowSrcs = [Edinburgh3, Oslo1, Gdansk, Dublin1]
const lastSrcs: string[] = []
const hiddenSrcs = [Paris1]
const shown = photos.filter((photo) => !hiddenSrcs.includes(photo.src))
const firstRow = firstRowSrcs.flatMap((src) => shown.filter((photo) => photo.src === src))

// the city without a date suffix (londonSep29 -> london), so photos from different days of the
// same city are kept apart too
const baseCity = (city: string) => city.replace(/(Sep|Oct)\d+$/, '')

export const oct2026Photos = [
  ...firstRow,
  ...shuffleSpread(
    shown.filter((photo) => !firstRowSrcs.includes(photo.src) && !lastSrcs.includes(photo.src)),
    (photo) => baseCity(photo.city),
    baseCity(firstRow[firstRow.length - 1].city),
  ),
  ...shown.filter((photo) => lastSrcs.includes(photo.src)),
]
